/**
 * Injection source for app-theme/assets/predictive-search.js
 * Purpose: avoid 417 "Unsupported buyer locale" from /search/suggest
 * https://shopify.dev/docs/api/ajax/reference/predictive-search#error-responses
 * by skipping predictive-search requests when Shopify flags it as unsupported.
 * https://shopify.dev/docs/api/ajax/reference/predictive-search#supported-languages
 */
(function () {
  function isPredictiveSearchEnabled() {
    const featuresElement = document.getElementById('shopify-features');
    if (!featuresElement?.textContent) return true;

    try {
      const features = JSON.parse(featuresElement.textContent);
      return features.predictiveSearch !== false;
    } catch (error) {
      return true;
    }
  }

  window.COSMONET_PREDICTIVE_SEARCH = {
    shouldSkipRequest() {
      return !isPredictiveSearchEnabled();
    },
  };
})();
